import React, { useEffect } from 'react';
import { Switch } from 'react-router';
import { SecureRoute } from '@okta/okta-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import BackToTop from '~COMPONENTS/BackToTop';

import orderRoutes from '../app/router/orderRoutes';

import { deepLinkInfoLoading } from '../user/selectors';
import { getIsGreaterChinaSalesOrg, getIsAustraliaSalesOrg, getIsJapanSalesOrg } from '../gamedayAccount/selectors';

export const Orders = ({ deepLinkInfoLoading, isGreaterChinaSalesOrg, isAustraliaSalesOrg, isJapanSalesOrg }) => {
  useEffect(() => {
    document.body.classList.add('orders');
    return () => document.body.classList.remove('orders');
  });

  if (deepLinkInfoLoading) {
    return null;
  }

  return (
    <div className='content bg-primary-grey'>
      <Switch>
        {orderRoutes.reduce((prevRoute, subRoute) => {
          if (
            (!subRoute.limitGc || !isGreaterChinaSalesOrg) &&
            (!subRoute.limitAu || !isAustraliaSalesOrg) &&
            (!subRoute.limitJp || !isJapanSalesOrg)
          ) {
            prevRoute.push(
              <SecureRoute
                key={subRoute.path}
                path={subRoute.path}
                exact={subRoute.exact}
                component={subRoute.component}
              />
            );
          }
          return prevRoute;
        }, [])}
      </Switch>
      <BackToTop />
    </div>
  );
};

Orders.propTypes = {
  deepLinkInfoLoading: PropTypes.bool.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired,
  isAustraliaSalesOrg: PropTypes.bool.isRequired,
  isJapanSalesOrg: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  deepLinkInfoLoading: deepLinkInfoLoading(state),
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state),
  isAustraliaSalesOrg: getIsAustraliaSalesOrg(state),
  isJapanSalesOrg: getIsJapanSalesOrg(state)
});

export default connect(mapStateToProps, {})(Orders);
